(function () {
    'use strict';

    angular
        .module('app.shared')
        .filter('isnull', isnullFilterFactory);

    isnullFilterFactory.$inject = ['$filter'];
    function isnullFilterFactory($filter) {
        return function isnullFilter(input, fallback) {
            // gap 3.8.2019 - add empty string check
            return input != null && input != '' ? input : fallback;
        }
    }
})();